// extracted by mini-css-extract-plugin
module.exports = {"fullScreenLoadContainer":"loading_fullScreenLoadContainer__1_EEo","content":"loading_content__3UCR8"};